import React from 'react';
import { useSelector } from 'react-redux';

import { needBoundingSelector, mapControlSelector, gensetTrackReportIdSelector } from '../../../features/map/mapSlice';

import OsmMapAssetBounder from './OsmMapAssetBounder';
import OsmMapZoneBounder from './OsmMapZoneBounder';
import OsmMapMarkerBounder from './OsmMapMarkerBounder';
import OsmMapTrackBounder from './OsmMapTrackBounder';
import OsmMapGensetBounder from './OsmMapGensetBounder';
import OsmGensetTrackBounder from './OsmGensetTrackBounder';
import OsmFindLatLngBounder from './OsmFindLatLngBounder';

const OsmMapControl = () => {
    const needBounding = useSelector(needBoundingSelector);
    const mapControl = useSelector(mapControlSelector);
    const gensetTrackReportId = useSelector(gensetTrackReportIdSelector);

    if (needBounding) {
        return (
            <div>
                {mapControl === 'asset' && <OsmMapAssetBounder />}
                {mapControl === 'zone' && <OsmMapZoneBounder />}
                {mapControl === 'marker' && <OsmMapMarkerBounder />}
                {mapControl === 'genset' && <OsmMapGensetBounder />}
                {mapControl === 'track' && gensetTrackReportId && <OsmGensetTrackBounder />}
                {mapControl === 'track' && !gensetTrackReportId && <OsmMapTrackBounder />}
                {mapControl === 'findlatlng' && <OsmFindLatLngBounder />}
            </div>
        )
    } else {
        return null;
    }
}

export default OsmMapControl;
